module.exports = __webpack_public_path__ + "img/12.2b13e06e.png";